var _circle, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8373 39.5811C20.0591 39.3594 20.364 39.23 20.6874 39.23H50.0141C50.55 39.23 50.8179 39.8768 50.4391 40.2556L44.6458 46.0489C44.4241 46.2706 44.1192 46.4 43.7958 46.4H14.4691C13.9332 46.4 13.6653 45.7532 14.0441 45.3744L19.8373 39.5811Z",
    fill: "url(#paint0_linear_549_10277)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8373 17.9511C20.0683 17.7294 20.3732 17.6 20.6874 17.6H50.0141C50.55 17.6 50.8179 18.2468 50.4391 18.6256L44.6458 24.4189C44.4241 24.6406 44.1192 24.77 43.7958 24.77H14.4691C13.9332 24.77 13.6653 24.1232 14.0441 23.7444L19.8373 17.9511Z",
    fill: "url(#paint1_linear_549_10277)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6458 28.6968C44.4241 28.4751 44.1192 28.3457 43.7958 28.3457H14.4691C13.9332 28.3457 13.6653 28.9925 14.0441 29.3713L19.8373 35.1646C20.0591 35.3863 20.364 35.5157 20.6874 35.5157H50.0141C50.55 35.5157 50.8179 34.8689 50.4391 34.4901L44.6458 28.6968Z",
    fill: "url(#paint2_linear_549_10277)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_549_10277",
    x1: -52.4167,
    y1: 12.1593,
    x2: -53.197,
    y2: 51.4229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_549_10277",
    x1: -61.2914,
    y1: 7.526,
    x2: -62.0717,
    y2: 46.7896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_549_10277",
    x1: -56.8823,
    y1: 9.82791,
    x2: -57.6626,
    y2: 49.0915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSol);
export default __webpack_public_path__ + "static/media/SOL.1a7e24d827ac07d2d2a953511ca72376.svg";
export { ForwardRef as ReactComponent };